import { render, staticRenderFns } from "./AddSupportTicketModal.vue?vue&type=template&id=3fbc6244&"
import script from "./AddSupportTicketModal.vue?vue&type=script&lang=js&"
export * from "./AddSupportTicketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports